const transformAll = ({ data }) => {
  const total = data.hazmatAgreements?.data?.total;
  data = data.hazmatAgreements?.data?.agreements?.map(({ ...rest }) => ({
    ...rest
  }));
  return { data, total };
};

export { transformAll };
